export default __webpack_public_path__ + "static/media/MANA.a39bb20b.png";